import { parse as parse$1 } from 'papaparse';
import React from 'react';
import PropTypes from 'prop-types';
import { FileUploadInput } from 'web-ui-components/lib/data/capture';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var ParseError =
/*#__PURE__*/
function (_Error) {
  _inherits(ParseError, _Error);

  function ParseError(message, rowData) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParseError).call(this, message));

    _defineProperty(_assertThisInitialized(_this), "rowData", void 0);

    _this.rowData = rowData;
    return _this;
  }

  return ParseError;
}(_wrapNativeSuper(Error));

var MIN_RECORDS_ERROR = Symbol('minrecords');
var MAX_RECORDS_ERROR = Symbol('maxrecords');
var PARSER_ERROR = Symbol('parser');
var FILE_TYPE_ERROR = Symbol('file type');
var FILE_ERROR = Symbol('file');
function minRecordsError(length) {
  return {
    type: MIN_RECORDS_ERROR,
    length: length
  };
}
function maxRecordsError(length) {
  return {
    type: MAX_RECORDS_ERROR,
    length: length
  };
}
function parserError(message, rowData) {
  return {
    type: PARSER_ERROR,
    message: message,
    rowData: rowData
  };
}
function fileTypeError(fileType) {
  return {
    type: FILE_TYPE_ERROR,
    fileType: fileType
  };
}
function fileError(message) {
  return {
    type: FILE_ERROR,
    message: message
  };
}

var validMimeTypes = ['application/vnd.ms-excel', 'text/csv', 'text/plain'];
var validFileExtensions = ['.csv', '.txt'];

function isValidFileType(type) {
  return validMimeTypes.includes(type);
}

function filterRow(data) {
  var ignoreEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (data.length === 1 && data[0] === '') {
    // empty line
    return false;
  }

  if (ignoreEmpty && data.every(function (value) {
    return value.length === 0;
  })) {
    // empty data
    return false;
  }

  return true;
}

function verifyRow(data) {
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ignoreExtraColumns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var verifiedData = ignoreExtraColumns ? data.slice(0, rules.length) : data;

  if (verifiedData.length !== rules.length) {
    throw new ParseError("Input wrong length", data);
  }

  rules.forEach(function (_ref, index) {
    var test = _ref.test,
        name = _ref.name;
    var value = verifiedData[index];

    if (!test(value)) {
      throw new ParseError("Invalid ".concat(name, ": ").concat(JSON.stringify(value)), data);
    }
  });
  return true;
}

function parseFile(file, options) {
  var minRecords = options.minRecords,
      maxRecords = options.maxRecords,
      onComplete = options.onComplete,
      onError = options.onError,
      ignoreEmpty = options.ignoreEmpty,
      ignoreExtraColumns = options.ignoreExtraColumns,
      getRules = options.getRules;

  if (!file) {
    return onError(fileError('No file selected'), file);
  }

  if (!isValidFileType(file.type)) {
    return onError(fileTypeError(file.type), file);
  }

  var getData = function getData(results, isHeaderRow) {
    if (isHeaderRow && results.data && isHeaderRow(results.data[0])) {
      return results.data.slice(1);
    }

    return results.data;
  };

  var handleComplete = function handleComplete(results) {
    var _ref2 = getRules ? getRules(results.data) : options,
        isHeaderRow = _ref2.isHeaderRow,
        rules = _ref2.rules;

    var data = getData(results, isHeaderRow).filter(function (rowData) {
      return filterRow(rowData, ignoreEmpty);
    });

    if (minRecords && data.length < minRecords) {
      return onError(minRecordsError(data.length), file);
    }

    if (maxRecords && data.length > maxRecords) {
      return onError(maxRecordsError(data.length), file);
    }

    var parsed;

    try {
      parsed = data.filter(function (rowData) {
        return verifyRow(rowData, rules, ignoreExtraColumns);
      });
    } catch (e) {
      return onError(parserError(e.message, e.rowData), file);
    }

    onComplete(parsed, file);
  };

  try {
    parse$1(file, {
      complete: handleComplete,
      error: function error(e) {
        return onError(fileError(e.message), file);
      },
      skipEmptyLines: true,
      worker: true
    });
  } catch (e) {
    onError(fileError(e.message), file);
  }
}

var acceptedFormats = [].concat(_toConsumableArray(validFileExtensions), _toConsumableArray(validMimeTypes)).join(',');
var FileInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileInput, _React$Component);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "fileInput", null);

    _this.state = {
      filenames: ''
    };
    return _this;
  }

  _createClass(FileInput, [{
    key: "getFileNames",
    value: function getFileNames(files) {
      if (files) {
        var filenames = [];

        for (var index = 0; index < files.length; index++) {
          var file = files.item(index);

          if (file) {
            filenames.push(file.name);
          }
        }

        return filenames.join(', ');
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          showFilename = _this$props.showFilename,
          onChange = _this$props.onChange,
          selectText = _this$props.selectText;
      var filenames = this.state.filenames;

      var onFileSelected = function onFileSelected(files) {
        onChange(files);

        _this2.setState({
          filenames: _this2.getFileNames(files)
        });
      };

      return React.createElement(FileUploadInput, {
        acceptedFormats: acceptedFormats,
        filename: filenames || 'No file chosen',
        hasFilename: showFilename,
        id: id,
        onChange: onFileSelected,
        selectText: selectText
      });
    }
  }]);

  return FileInput;
}(React.Component);

_defineProperty(FileInput, "propTypes", {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectText: PropTypes.string,
  showFilename: PropTypes.bool
});

_defineProperty(FileInput, "defaultProps", {
  selectText: undefined,
  showFilename: undefined
});

// TODO: fix
var keyMirror = function keyMirror(obj) {
  return Object.keys(obj).reduce(function (collection, key) {
    return _objectSpread2({}, collection, _defineProperty({}, key, key));
  }, {});
};

var _keyMirror = keyMirror({
  SELECT_FILES: null,
  PARSE: null,
  PARSE_COMPLETE: null,
  PARSE_ERROR: null
}),
    SELECT_FILES = _keyMirror.SELECT_FILES,
    PARSE = _keyMirror.PARSE,
    PARSE_COMPLETE = _keyMirror.PARSE_COMPLETE,
    PARSE_ERROR = _keyMirror.PARSE_ERROR;
function selectFile(file) {
  return {
    type: SELECT_FILES,
    payload: file
  };
}
function parse() {
  return {
    type: PARSE
  };
}
function parseComplete() {
  return {
    type: PARSE_COMPLETE
  };
}
function parseError() {
  return {
    type: PARSE_ERROR
  };
}

var INITIAL_STATE = {
  isLoading: false,
  file: null
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SELECT_FILES:
      return _objectSpread2({}, state, {
        file: action.payload
      });

    case PARSE:
      {
        return _objectSpread2({}, state, {
          isLoading: true
        });
      }

    case PARSE_COMPLETE:
    case PARSE_ERROR:
      {
        return _objectSpread2({}, state, {
          isLoading: false
        });
      }

    default:
      return state;
  }
};

var FileParser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileParser, _React$Component);

  function FileParser(props) {
    var _this;

    _classCallCheck(this, FileParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileParser).call(this, props));
    _this.state = INITIAL_STATE;
    return _this;
  }

  _createClass(FileParser, [{
    key: "dispatch",
    value: function dispatch(action) {

      this.setState(function (state) {
        return reducer(state, action);
      });
    }
  }, {
    key: "parse",
    value: function parse$1(file) {
      var _this2 = this;

      if (file) {
        var _this$props = this.props,
            onComplete = _this$props.onComplete,
            onError = _this$props.onError,
            rules = _this$props.rules,
            isHeaderRow = _this$props.isHeaderRow,
            minRecords = _this$props.minRecords,
            maxRecords = _this$props.maxRecords,
            ignoreEmpty = _this$props.ignoreEmpty,
            ignoreExtraColumns = _this$props.ignoreExtraColumns;

        var handleComplete = function handleComplete(results, successFile) {
          _this2.dispatch(parseComplete());

          onComplete(results, successFile);
        };

        var handleError = function handleError(error, errorFile) {
          _this2.dispatch(parseError());

          onError(error, errorFile);
        };

        this.dispatch(parse());
        parseFile(file, {
          onComplete: handleComplete,
          onError: handleError,
          rules: rules,
          isHeaderRow: isHeaderRow,
          minRecords: minRecords,
          maxRecords: maxRecords,
          ignoreEmpty: ignoreEmpty,
          ignoreExtraColumns: ignoreExtraColumns
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          selectText = _this$props2.selectText,
          showFilename = _this$props2.showFilename;

      var onChange = function onChange(files) {
        if (files) {
          var _file = files.item(0);

          if (_file) {
            _this3.dispatch(selectFile(_file));

            _this3.parse(_file);
          }
        }
      };

      return React.createElement(FileInput, {
        id: id,
        onChange: onChange,
        showFilename: showFilename,
        selectText: selectText
      });
    }
  }]);

  return FileParser;
}(React.Component);

_defineProperty(FileParser, "propTypes", {
  id: PropTypes.string.isRequired,
  isHeaderRow: PropTypes.func,
  rules: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    test: PropTypes.func.isRequired
  })),
  display: PropTypes.oneOf(['primary', 'secondary']),
  onComplete: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  selectText: PropTypes.string,
  minRecords: PropTypes.number,
  maxRecords: PropTypes.number,
  ignoreEmpty: PropTypes.bool,
  ignoreExtraColumns: PropTypes.bool,
  showFilename: PropTypes.bool
});

_defineProperty(FileParser, "defaultProps", {
  isHeaderRow: undefined,
  selectText: undefined,
  minRecords: undefined,
  maxRecords: undefined,
  ignoreEmpty: false,
  ignoreExtraColumns: false,
  showFilename: undefined
});

export { FILE_ERROR, FILE_TYPE_ERROR, FileInput, FileParser, MAX_RECORDS_ERROR, MIN_RECORDS_ERROR, PARSER_ERROR, parseFile };
